export const ConsolidationDocumentKind = { manifest: "manifest" } as const;
export type ConsolidationDocumentKind =
  (typeof ConsolidationDocumentKind)[keyof typeof ConsolidationDocumentKind];

export const ConsolidationDocumentFormat = { csv: "csv", pdf: "pdf" } as const;
export type ConsolidationDocumentFormat =
  (typeof ConsolidationDocumentFormat)[keyof typeof ConsolidationDocumentFormat];
